module.exports = __webpack_public_path__ + "static/media/video-cover.e57421bd.png";